export default "__VITE_PUBLIC_ASSET__8dddbd76__"